import { render, staticRenderFns } from "./ButtonRight.vue?vue&type=template&id=b7b41356&"
import script from "./ButtonRight.vue?vue&type=script&lang=js&"
export * from "./ButtonRight.vue?vue&type=script&lang=js&"
import style0 from "./ButtonRight.vue?vue&type=style&index=0&id=b7b41356&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports